import React, { useState, useEffect, Fragment } from 'react'
import './AddOrEditProduct.css';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addProduct, getProduct, updateProduct, getProducts, getProductsCategoriesCreated, editProduct, getInstitutionsWithoutBCC } from '../../services/http';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Select from 'react-select';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';
// import "../../assets/css/bootstrap/css/bootstrap.min.css"
// import "../../assets/importedCss/structure.css"
// import "../../assets/importedCss/bootstrap.min.css"




const AddOrEditProduct = (props) => {

    const { show, handleClose, idProduct, oldLabel, oldCategoryLabel, operationType } = props;

    const navigate = useNavigate();

    const id_product = useParams()

    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);

    const [processOngoing, setProcessOngoing] = useState(false)
    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);


    // const [produit, setProduit] = useState({ libelle: operationType == "new" ? "" : states.currentProduct.libelle, categoryId: operationType === "new" ? "" : states.currentProduct.category_product_id });
    const [produit, setProduit] = useState({ libelle: "", category: { value: "", label: "" }, institution: { value: "", label: "" } });

    const [productCategories, setProductCategories] = useState([]);

    const [categories, setCategories] = useState([{ value: "", label: "" }]);
    const [institutions, setInstitutions] = useState([{ value: "", label: "" }]);

    useEffect(() => {

        if (operationType !== "new") {
            if (states.userInfo.isBcc === 0) {
                if (produit.institution.value === "") {
                    const { id, libelle } = states.userInfo?.institution
                    setProduit({ ...produit, institution: { value: id, label: libelle } })
                }
            }
        }
    }, [produit.institution]);
    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        let type = operationType === "new" ? "Création" : "Modification"
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "/product", secondLevelText: "Produit", secondLevelLink: "/product", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("product", dispatch)
    }, [])

    const loadProductCategories = async () => {
        const resp = await getProductsCategoriesCreated(states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)

            setProductCategories(resp.data)

            const newData = resp.data.map(value => ({
                value: value.id,
                label: value.libelle,
            }))
            setCategories(newData)
            console.log(categories[2])

            console.log(resp.data[0])
            // setProduit({ ...produit, categoryId: resp.data[0].id })


        }

    }

    const loadInstitutions = async () => {
        const resp = await getInstitutionsWithoutBCC(states.userToken.access_token);
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)

            const newData = resp.data.map(value => ({
                value: value.id,
                label: value.libelle,
            }))
            setInstitutions(newData)
        }

    }

    const [showErrorLibelle, setShowErrorLibelle] = useState(false)
    const [showErrorCategory, setShowErrorCategory] = useState(false)
    const [showErrorInstitution, setShowErrorInstitution] = useState(false)

    const [errorMessageLibelle, setErrorMessageLibelle] = useState("")
    const [errorMessageCategory, setErrorMessageCategory] = useState("")
    const [errorMessageInstitution, setErrorMessageInstitution] = useState("")


    const handleChangeLabel = (e) => {
        var value = e.currentTarget.value;
        var name = e.currentTarget.name
        setProduit({ ...produit, libelle: value });
    }

    useEffect(() => {

        if (states.userInfo?.isBcc == 0) {
            console.log(states.userInfo.institution.id)
            console.log(states.userInfo.institution.libelle)
            setProduit({ ...produit, institution: { value: states.userInfo?.institution?.id, label: states.userInfo?.institution?.libelle } })
        }
    }, []);

    const handleAddProduct = async (type) => {
        let instit_id = states.userInfo?.isBcc == 0 ? states.userInfo?.institution?.id : "";
        // if (states.userInfo?.isBcc == 0) {
        //     console.log(states.userInfo.institution.id)
        //     console.log(states.userInfo.institution.libelle)
        //     setProduit({ ...produit, institution: { value: states.userInfo?.institution?.id, label: states.userInfo?.institution?.libelle } })
        // }
        setProcessOngoing(true)
        // if(produit. == "") {
        //     console.log(states.userInfo.isBcc == 0)
        //     console.log(states.userInfo.institution.libelle)
        //     setProduit({...produit, institution: {value: states.userInfo?.institution?.id,  label:states.userInfo?.institution?.libelle}})
        // }
        console.log("Here is product to add", produit)
        const reqdata = await addProduct(produit, states.userToken.access_token, instit_id);
        if (reqdata.response && reqdata.response.status !== 200) {
            console.log(reqdata.response?.data)
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                console.log("Here we are", reqdata.response)
                if (reqdata.response?.data?.error?.libelle) {
                    var errorMsg = reqdata.response?.data.error["libelle"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorLibelle(true)
                    setErrorMessageLibelle(errorMsg)
                }
                // else {
                //     var errorMsg = reqdata.response?.data;
                //     console.log("Error Msg ", errorMsg)
                //     setShowErrorLibelle(true)
                //     setErrorMessageLibelle(errorMsg)
                // }
                if (reqdata.response?.data?.error?.categoryproduct_id) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["categoryproduct_id"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorCategory(true)
                    setErrorMessageCategory(errorMsg)
                }
                if (!reqdata.response?.data?.error) {
                    console.log(reqdata.response?.data)
                    toast.error(reqdata.response?.data, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                if (reqdata.response?.data?.error?.institution) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["institution"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorInstitution(true)
                    setErrorMessageInstitution(errorMsg)
                }
                if (reqdata.response?.data?.error?.institution) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["institution"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorInstitution(true)
                    setErrorMessageInstitution
                        (errorMsg)
                }
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.message)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Nouveau Produit ${produit.libelle} ajouté avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });

            setProduit({ ...produit, libelle: "", category: { value: "", label: "" }, institution: { value: "", label: "" } })

            let response = await getProducts(states.userToken.access_token, 1, "");

            let response_copy = response.data?.data.map(obj => ({ ...obj, showDelete: false }))

            dispatch({
                type: "SET",
                key: "productList",
                payload: response_copy,
            });
            if (type == "retourner") { navigate("/product") }

        }

    }


    const handleEditProduct = async () => {
        let instit_id = states.userInfo?.isBcc == 0 ? states.userInfo?.institution?.id : "";

        // if (states.userInfo?.isBcc == 0) {
        //     console.log(states.userInfo.institution.id)
        //     console.log(states.userInfo.institution.libelle)
        //     setProduit({ ...produit, institution: { value: states.userInfo?.institution?.id, label: states.userInfo?.institution?.libelle } })
        // }
        // console.log("idProduit", id_product)
        // console.log("idProduit", produit.categoryId)
        console.log("institution", produit.institution)
        setProcessOngoing(true)
        const reqdata = await updateProduct(id_product, produit, states.userToken.access_token, instit_id);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                if (reqdata.response?.data.error.libelle) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["libelle"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorLibelle(true)
                    setErrorMessageLibelle(errorMsg)
                }
                // else {
                //     var errorMsg = reqdata.response?.data;
                //     console.log("Error Msg ", errorMsg)
                //     setShowErrorLibelle(true)
                //     setErrorMessageLibelle(errorMsg)
                // }
                if (reqdata.response?.data.error.categoryproduct_id) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["categoryproduct_id"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorCategory(true)
                    setErrorMessageCategory(errorMsg)
                }
                if (!reqdata.response?.data?.error) {
                    console.log(reqdata.response?.data)
                    toast.error(reqdata.response?.data, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                if (reqdata.response?.data.error.institution) {
                    setProcessOngoing(false)
                    var errorMsg = reqdata.response?.data.error["institution"][0];
                    console.log("Error Msg ", errorMsg)
                    setShowErrorInstitution(true)
                    setErrorMessageInstitution
                        (errorMsg)
                }
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification effectuée !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            let response = await getProducts(states.userToken.access_token, 1, "");
            let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
            // dispatch({
            //     type: "SET",
            //     key: "currentProduct",
            //     payload: {},
            // });
            dispatch({
                type: "SET",
                key: "productList",
                payload: response_copy,
            });
            handleBack();
        }
    }

    const handleBack = () => {
        navigate("/product")
    }


    useEffect(() => {
        if (produit.libelle != "") {
            setShowErrorLibelle(false)
        }
        if (produit.category.value != "") {
            setShowErrorCategory(false)
        }
        if (produit.institution.value != "") {
            setShowErrorInstitution(false)
        }
    }, [produit])


    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          background: '#fff',
          borderColor: '#9e9e9e',
          minHeight: '35px',
          height: '35px',
          boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
          ...provided,
          height: '35px',
          padding: '0 6px',
          marginTop: '-5px'
        }),
    
        input: (provided, state) => ({
          ...provided,
          margin: '0px',
        }),
        indicatorSeparator: state => ({
          display: 'none',
        //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          height: '35px',
        }),
      };

    const handleSelection = (e, key) => {
        // let values = []
        // e.map(a => values.push(a.value));
        // console.log("values", typeof values)
        console.log(e)
        if (key == "category") {
            setProduit({ ...produit, category: { value: e.value, label: e.label } })
        }
        if (key == "institution") {
            setProduit({ ...produit, institution: { value: e.value, label: e.label } })
        }
    }

    useEffect(() => {
        loadProductCategories();
        loadInstitutions();
        if (operationType !== "new") {
            loadProductData();
        }
        console.log(productCategories)

    }, [])

    const loadProductData = async () => {
        const resp = await editProduct(id_product, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data produit", resp.data)
            let data_received = resp.data?.product;
            console.log(data_received)
            setProduit({ ...produit, libelle: data_received.libelle, category: { value: data_received.category_product.id, label: data_received.category_product.libelle }, institution: { value: data_received.institution.id, label: data_received.institution.libelle } })
            setDisplayLoader(false)
        }

        console.log(produit)

    }




    return (
        <>
            <div>
                <Navbar />
                <div className="main-container" id="container">
                    <Sidebar />

                    <div id="content" className="main-content">
                        <div className="layout-px-spacing m-auto">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            {
                                displayLoader == false ?
                                    <div className="widget widget-content widget-content-area mx-auto">
                                        <div className="w-90 mx-auto">
                                            <h5 className="modal-title py-2 text-left">{operationType == "new" ? "Nouveau Produit" : "Modifier Produit"}</h5>
                                        </div>
                                        <hr />

                                        <Modal.Body className="modal-body">
                                            <div class="form-group row  w-80 mx-auto mb-4">

                                                <div class="form-group row  w-80 mx-auto mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Libellé</label>
                                                    <div class="col-sm-9">
                                                        <input type="text" onChange={handleChangeLabel} className={showErrorLibelle == true ? "form-control custom-form-control new-institution-category-error-input w-100  mx-auto" : "form-control custom-form-control form-control-sm w-100 mx-auto"} id="colFormLabelSm" placeholder="" value={produit.libelle} required />
                                                        {showErrorLibelle === true && <span className="new-institution-category-error-span">{errorMessageLibelle}</span>}
                                                    </div>
                                                </div>

                                                <div class="form-group row w-80 mx-auto mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Catégorie</label>

                                                    <div class="col-sm-9">
                                                        <Select
                                                            onChange={(e) => handleSelection(e, 'category')}
                                                            placeholder=""
                                                            className={showErrorCategory == true ? "new-institution-error-input " : ""}
                                                            classNamePrefix="select"
                                                            value={produit.category.label !== "" ? produit.category : ""}
                                                            isDisabled={false}
                                                            isLoading={false}
                                                            isClearable={false}
                                                            isRtl={false}
                                                            isSearchable={false}
                                                            name="product-category"
                                                            options={categories}
                                                            styles={customStyles}
                                                        />
                                                        {showErrorCategory === true && <span className="new-institution-category-error-span">{errorMessageCategory}</span>}

                                                    </div>
                                                </div>
                                                {states.userInfo.isBcc == 1 && <div class="form-group row mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Institution</label>

                                                    <div class="col-sm-9">
                                                        <Select
                                                            onChange={(e) => handleSelection(e, 'institution')}
                                                            placeholder=""
                                                            className=""
                                                            classNamePrefix="select"
                                                            value={produit.institution.label !== "" ? produit.institution : ""}
                                                            isDisabled={false}
                                                            isLoading={false}
                                                            isClearable={false}
                                                            isRtl={false}
                                                            isSearchable={false}
                                                            name="product-category"
                                                            options={institutions}
                                                            styles={customStyles}
                                                        />
                                                        {showErrorInstitution == true && <span className="new-institution-category-error-span">{errorMessageInstitution}</span>}

                                                    </div>
                                                </div>}
                                            </div>
                                        </Modal.Body>
                                        <hr />
                                        <div className="new-institution-custom-modal-footer w-90 pb-3">
                                            {processOngoing == false ? <Fragment>
                                                <button type="button"
                                                    title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                                    className="btn btn-primary ml-3"
                                                    onClick={operationType == "new" ? () => handleAddProduct("rester") : handleEditProduct}>
                                                    {operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}
                                                </button>
                                                {operationType == "new" &&
                                                    <button type="button"
                                                        title={"Ajouter et retourner à la liste"}
                                                        className="btn btn-primary ml-3"
                                                        onClick={() => handleAddProduct("retourner")}>
                                                        Ajouter et Retourner</button>
                                                }
                                            </Fragment> : <ProcessSpinner />}
                                            <button className="btn ml-3" data-dismiss="modal"
                                                onClick={() => navigate("/product")}
                                            ><i className="flaticon-cancel-12"></i>Retour</button>
                                        </div>
                                    </div> : <div style={{ marginTop: "25%" }}>
                                        <Loader />
                                    </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default AddOrEditProduct
